<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Filters for {{ panelName | async }}</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="nav-tabs">
    <li ngbNavItem="filtersGrid" ngbTooltip="Press 1 to focus tab">
      <a ngbNavLink>Table Filters</a>
      <ng-template ngbNavContent>
        <nf-checkbox
          *ngIf="accessDeveloperTools$ | async"
          [formControl]="filterEditorToggle"
          label="Use new filter editor"
        >
        </nf-checkbox>

        <hs-filter-editor
          *ngIf="filterEditorToggle.value; else filterGrid"
          [(editorModel)]="editorModel"
          [enableColumnTypeOverride]="enableColumnTypeOverride"
        ></hs-filter-editor>

        <ng-template #filterGrid>
          <hs-filter-grid
            [data]="gridData"
            [validators]="validators"
            (complete)="onApply()"
            (change)="onChange($event)"
            (close)="activeModal.dismiss()"
          ></hs-filter-grid>
        </ng-template>
      </ng-template>
    </li>
    <li
      ngbNavItem="advancedOptions"
      ngbTooltip="Press 1 to focus tab"
      *ngIf="advancedOptions != null"
    >
      <a ngbNavLink>Advanced Options</a>
      <ng-template ngbNavContent>
        <hs-advanced-options
          #advancedOptionsComponent
          [advancedOptions]="advancedOptions"
          [advancedOptionsParams]="advancedOptionsParams"
          (change)="advancedOptionsParams = $event"
        ></hs-advanced-options>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="content"></div>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div class="left">
    <button nf-button (click)="clearAllFilters()" *ngIf="enableClearFilters">
      Clear All Filters
    </button>
    <button nf-button (click)="resetAllFilters()" *ngIf="enableResetFilters">
      Reset Filters to Default
    </button>
  </div>
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      nf-button="primary"
      (click)="onApply()"
      data-cy="applyFiltersButton"
    >
      Apply
    </button>
  </div>
</div>
